/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import "./style/createPdfTemplate.scss"

import React, {MouseEventHandler, useEffect, useRef} from 'react';
import {
    IndexedObject,
    Loader,
    PDFElementParams,
    PdfFont,
    PDFSubmitHandler,
    PDFTemplateCreator,
} from '@dvrd/dvr-controls';
import {getMenuWidth} from "../../../util/menuUtil";
import {CUSTOM_VARIABLES} from '../../../util/pdfUtil';
import {BolmateButton} from "../../controls";
import InfoBanner from "../../misc/infoBanner";


interface Props {
    onPreview: PDFSubmitHandler;
    onSubmit: PDFSubmitHandler;
    onClickProceed: PDFSubmitHandler | null;
    onChangeFont: (font: PdfFont, callback?: VoidFunction) => void;
    onClickImport: MouseEventHandler;
    elements: PDFElementParams<any, any>[];
    resetElements: PDFElementParams<any, any>[];
    loading: boolean;
    values: IndexedObject<string>;
    mainFont: PdfFont;
    version: number;
    hasAccounts: boolean;
}

export default function PdfTemplateEditor(props: Props) {
    const {
        onClickProceed, onChangeFont, elements, onPreview, loading, onSubmit, resetElements, values, mainFont,
        version, hasAccounts, onClickImport
    } = props;
    const maxWidth = getMenuWidth();
    const creatorRef = useRef<PDFTemplateCreator>(null);
    const lastVersion = useRef<number>(-1);

    useEffect(() => {
        if (lastVersion.current !== version) {
            lastVersion.current = version;
            if (creatorRef.current) creatorRef.current.onReset();
        }
    }, [version]);

    return (
        <>
            <InfoBanner featureKey='invoice_layout' variant='info'
                        title='Factuurlayout'
                        message='Ontwerp je factuurlayout zodat elke factuur in je eigen huisstijl verstuurd wordt.'
                        showForNewUsersOnly={true}/>
            <div className='create-pdf-template'>
                <Loader active={loading} position='fixed'/>
                <PDFTemplateCreator onSubmit={onSubmit} defaultItems={elements} customVariables={CUSTOM_VARIABLES}
                                    resetItems={resetElements} onClickProceed={onClickProceed ?? undefined}
                                    maxWidth={`calc(100vw - ${maxWidth}px)`} values={values} onPreview={onPreview}
                                    onChangeFont={onChangeFont} mainFont={mainFont} disableElements={['invoiceTable']}
                                    headerButtons={hasAccounts ? [<BolmateButton onClick={onClickImport}
                                                                                 label="Ophalen uit..."/>] : undefined}
                                    ref={creatorRef} supportMultiPage singleImage
                                    tableHeaderLabels={['Productnaam', 'Aantal', 'Prijs', 'BTW', 'Subtotaal excl. BTW']}/>
            </div>
        </>
    )
}
